const REMOVE_SELECTED_PAGE = 'myCards/REMOVE_SELECTED_PAGE';
const SET_CARD_COVER_IMAGE = 'myCards/SET_CARD_COVER_IMAGE';
const RESET_SELECTED_PAGE = 'myCards/RESET_SELECTED_PAGE';
const ADD_SELECTED_PAGE = 'myCards/ADD_SELECTED_PAGE';
const MAKE_CARD_PRIVATE = 'myCards/MAKE_CARD_PRIVATE';
const MAKE_CARD_PUBLIC = 'myCards/MAKE_CARD_PUBLIC';
const SET_CARD_SHARE_LEVEL = 'myCards/SET_CARD_SHARE_LEVEL';
const SET_CARD_PAGES = 'myCards/SET_CARD_PAGES';
const REMOVE_CARD = 'myCards/REMOVE_CARD';
const UPDATE_CARD = 'myCards/UPDATE_CARD';
const SET_CARDS = 'myCards/SET_CARDS';
const ADD_CARDS = 'myCards/ADD_CARDS';

export default {
  REMOVE_SELECTED_PAGE,
  SET_CARD_COVER_IMAGE,
  RESET_SELECTED_PAGE,
  ADD_SELECTED_PAGE,
  MAKE_CARD_PRIVATE,
  MAKE_CARD_PUBLIC,
  SET_CARD_SHARE_LEVEL,
  SET_CARD_PAGES,
  REMOVE_CARD,
  UPDATE_CARD,
  SET_CARDS,
  ADD_CARDS,
};



// WEBPACK FOOTER //
// ./src/app/my-cards/store/mutation-types.js